import { render, staticRenderFns } from "./WalkTech.vue?vue&type=template&id=55a86858&"
import script from "./WalkTech.vue?vue&type=script&lang=ts&"
export * from "./WalkTech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports